import { Record } from 'immutable';
import type ErrorRecord from '~/data/ErrorRecord';
import type EditUserUserRecord from './EditUserUserRecord';

const keys: Fields = {
  isLoading: false,
  hasLoaded: false,
  isModalOpen: false,
  isSubmitting: false,
  userId: '',
  user: undefined,
  loadUserError: undefined,
  error: undefined,
};

interface Fields {
  isLoading: boolean;
  hasLoaded: boolean;
  isModalOpen: boolean;
  isSubmitting: boolean;
  userId: string;
  user?: EditUserUserRecord;
  loadUserError?: ErrorRecord;
  error?: ErrorRecord;
}

export default class EditUserRecord extends Record<Fields>(keys) {}
